import FilterInput from 'components/Form/filterInput';
import FilterDrawerShell from 'components/Form/filterDrawerShell';
import FilterSection, { FilterField } from 'components/Form/filterSection';
import FilterSelect from "components/Form/filterSelect";
import { countActive, filterValueOf } from 'components/Form/filterValues';
import { useCallback } from 'react';

const KEYS = ["user", "email"];

const SalaryFilterDrawer = ({
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleClearAll,
    isFilterDirty
}) => {
  // The user list for this drawer has never been wired to a data source;
  // the select is kept so the existing `user` URL filter still round-trips.
  const userOption = [];
  const setFilterValue = useCallback((key) => {
    const selected = filters?.find(item => item.key === key)
    return selected?.value ? selected : ""
  }, [filters]);
  return (
    <FilterDrawerShell
      open={showFilterDrawer}
      onClose={handleFilterDrawer}
      activeCount={countActive(filters, KEYS)}
      onClearAll={handleClearAll}
      onApply={handleApplyFilter}
      applying={filterLoading}
      applyDisabled={!isFilterDirty}
    >
      <FilterSection title="Employee" count={countActive(filters, KEYS)}>
        <FilterField label="Employee" htmlFor="filter-salary-user">
          <FilterSelect inputId="filter-salary-user" menuPosition="fixed" isClearable={true} onChange={e=>{handleFilterChange(e, "user")}} optionLabel={"label"} optionValue={'value'} options={userOption} value={setFilterValue("user")} placeholder={"Any"}/>
        </FilterField>
        <FilterField label="Email" htmlFor="email">
          <FilterInput
            defaultValue={filterValueOf(filters, "email")}
            onChange={e=>{handleInputChange(e.target.value, "email", true)}}
            id="email"
            label={"Email"}
          />
        </FilterField>
      </FilterSection>
    </FilterDrawerShell>
  );
};
export default SalaryFilterDrawer;
